import React, { useCallback, useEffect, useState } from 'react';
import { Box, Fade, Modal, Typography } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import { did, global, included, input, menu, profile, sip } from "../translate";
import { useDispatch, useSelector } from "react-redux";
import { didCreate, didCreateGet, didEdit } from "../store/actions/did";
import Api from "../Api";
import TelegramCode from "./TelegramCode";
import TelegramEmail from "./TelegramEmail";
import Cookies from "js-cookie";
import CloseIcon from "@mui/icons-material/Close";
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import { style, customStyles } from "../helpers/style";

const { REACT_APP_SERVER } = process.env;


function AddAndEditDidNumbers({ open, edit, setOpen }) {
    const [form, setForm] = useState({
        operator: '',
        note: '',
        ord: 1,
        caller_visible_type: 0,
        no_action: '',
        phone: '',
        profile: '',
        serverHost: '',
        username: '',
        password: '',
        forward: '',
        line: '1'
    })
    const handleWheel = useCallback((event) => {
        event.target.blur();
        event.preventDefault();
    }, []);
    const userData = useSelector((state) => state.users.userData)
    const [telegram, setTelegram] = useState('')
    const [isEmail, setIsEmail] = useState('')
    const [session, setSession] = useState('')
    const [shorts, setShorts] = useState([])
    const [storage, setStorage] = useState('')
    const [loader, setLoader] = useState(false)
    const [isTel, setIsTel] = useState(false)
    const [loading, setLoading] = useState(!!edit)
    const dispatch = useDispatch()
    const didCreateData = useSelector(state => state.did.didCreateData)
    const isAdmGroup5 = String(userData?.admgroup) === '5'
    const admGroup5Providers = (didCreateData?.provider || []).filter((p) => ['4', '6', '7'].includes(String(p.name)))
    const handleChange = useCallback((name, ev) => {
        if (name === 'operator' && ev === '1') {
            setForm((prevState) => ({
                ...prevState,
                operator: ev,
                phone: '374',
                profile: '',

            }))
        } else if (name === 'operator' && ev === '2') {
            setForm((prevState) => ({
                ...prevState,
                operator: ev,
                phone: '',
                profile: '',
            }))
        } else if (name === 'operator' && ev === '3') {
            setForm((prevState) => ({
                ...prevState,
                operator: ev,
                profile: '45',
                serverHost: 'sip.tg',
                phone: ''
            }))
        } else {
            setForm((prevState) => ({
                ...prevState,
                [name]: ev,

            }))
        }


    }, [])
    const handleAdd = useCallback(async (ev) => {
        ev.preventDefault()
        try {
            if (edit) {
                await dispatch(didEdit(form, edit.split('_')[1]))
                setOpen(false)
            } else {
                if (+form.operator === 4 && !form.username) {
                    setLoader(true)
                    const { data } = await Api.telegReg(form.phone)
                    setTelegram(form.phone)
                    setSession(data.session_id)
                    setStorage(data.storage_id)
                    setLoader(false)

                } else if (+form.operator === 4) {
                    await dispatch(didCreate({ ...form, phone: form.phone, username: '' }))
                    setOpen(false)

                } else {
                    await dispatch(didCreate({ ...form, phone: form.phone }))
                    setOpen(false)
                }
            }
        } catch (e) {

        }
    }, [form])
    useEffect(() => {
        (async () => {
            await dispatch(didCreateGet())
        })()
    }, [])
    useEffect(() => {
        (async () => {
            if (telegram === 'success') {
                if (+form.operator === 4) {
                    await dispatch(didCreate({ ...form, phone: form.phone, username: '' }))
                    setOpen(false)

                }
            }
            // await dispatch(didCreateGet())
        })()
    }, [telegram, form])
    useEffect(() => {
        if (edit) {
            (async () => {
                try {
                    const [did, provider] = edit.split('_')

                    const { data } = await Api.singleDid(did, provider)
                    if (+data?.did?.redirect?.provider === 45) {
                        setIsTel(true)
                    } else {
                        setIsTel(false)
                    }

                    setForm({
                        operator: data?.did?.provider,
                        note: data?.did?.notes,
                        ord: data?.did?.ord,
                        caller_visible_type: !!data?.did?.caller_visible_type,
                        no_action: data?.did?.no_action || '',
                        phone: data?.did?.pref + data.did?.did,
                        profile: data?.did?.redirect?.provider,
                        serverHost: data?.did?.redirect?.server_host,
                        username: data?.did?.redirect?.username,
                        password: data?.did?.redirect?.password,
                        forward: data?.did?.output?.output || '',
                        line: data?.did?.dlines
                    })
                    const short = await Api.shortForVirtual()
                    setShorts(short.data.short)

                    setLoading(false)
                } catch (e) {

                }
            })()


        }
    }, [edit])

    if (loading) return null
    return (
        <>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <div className="d-flex flex-row justify-content-between">
                            <Typography id="transition-modal-title" variant="h6" component="h2">
                                {menu.did[+localStorage.getItem('atsLang') || 1]}
                            </Typography>
                            <span style={{ cursor: 'pointer' }} onClick={() => setOpen(false)}>
                                <CloseIcon />

                            </span>
                        </div>

                        <form onSubmit={handleAdd}>
                            <div id="transition-modal-description sip_content" className="row" style={{ marginTop: 20 }}>
                                <label className="col-md-12 count" style={{ margin: '20px 0' }}><span>
                                    {did.operator[+localStorage.getItem('atsLang') || 1]} :
                                </span>
                                    <select
                                        disabled={edit}
                                        value={form.operator}
                                        onChange={(ev) => handleChange('operator', ev.target.value)}
                                        style={{ height: 40, border: '1px solid #ccc', outline: 'none' }}>
                                        <option value="">{input.select[+localStorage.getItem('atsLang') || 1]}</option>
                                        {isAdmGroup5 ? (
                                            admGroup5Providers.map((p) => (
                                                <option value={p.name} key={p.name}>{p.title}</option>
                                            ))
                                        ) : (
                                            <>
                                                {Cookies.get('viewer') && Cookies.get('original') ? didCreateData?.provider?.filter(d => d.name !== 3).map(p => (
                                                    <option value={p.name} key={p.name}>{p.title}</option>
                                                )) : <option value="4">telegram-gw</option>}
                                                {Cookies.get('viewer') && Cookies.get('original') ? null :
                                                    <option value="1">Ucom</option>}
                                            </>
                                        )}
                                    </select>
                                </label>
                                <label className="count col-md-12">
                                    <span>
                                        {included.phone[+localStorage.getItem('atsLang') || 1]} :
                                        {+form.profile === 45 ? form.username : ""}
                                    </span>
                                    <input value={form.phone} readOnly={edit}
                                        onChange={(ev) => handleChange('phone', ev.target.value)} />
                                </label>
                                {Cookies.get('viewer') && Cookies.get('original') && REACT_APP_SERVER !== 'Beeline' ?
                                    <label className="col-md-12 count" style={{ margin: '15px 0 5px' }}>
                                        <span className="d-flex align-items-center">
                                            {did.incoming[+localStorage.getItem('atsLang') || 1]}:
                                            <input style={{ marginLeft: 20 }}
                                                className="w-auto"
                                                type="checkbox"
                                                disabled={edit}
                                                checked={!form.ord}
                                                onChange={(ev) => handleChange('ord', ev.target.checked ? 0 : 1)} />
                                        </span>

                                    </label> : null}
                                <label style={{ margin: '20px 0' }} className="count col-md-12">
                                    <span>
                                        {sip.note[+localStorage.getItem('atsLang') || 1]} :
                                    </span>
                                    <input value={form.note} onChange={(ev) => handleChange('note', ev.target.value)} />
                                </label>


                                <Tooltip id="my-tooltip" />

                                {edit ? <label data-tooltip-content={did.visibleExplain[+localStorage.getItem('atsLang') || 1]}
                                    data-tooltip-id="my-tooltip" className="col-md-12 count" style={{ margin: '5px 0' }}>
                                    <span className="d-flex align-items-center">
                                        {did.visible[+localStorage.getItem('atsLang') || 1]}:
                                        <input style={{ marginLeft: 20 }}
                                            className="w-auto"
                                            type="checkbox"
                                            checked={form.caller_visible_type}
                                            onChange={(ev) => handleChange('caller_visible_type', ev.target.checked ? 1 : 0)} />
                                    </span>

                                </label> : null}
                                {Cookies.get('viewer') && Cookies.get('original') ?
                                    <label style={{ margin: '20px 0' }} className="count col-md-12">
                                        <span>
                                            {sip.forward[+localStorage.getItem('atsLang') || 1]} :
                                        </span>
                                        <input value={form.forward} onChange={(ev) => handleChange('forward', ev.target.value)} />
                                    </label> : null}
                                {edit ?
                                    <label className="col-md-12 count" style={{ margin: '5px 0' }}>
                                        <span className="d-flex align-items-center">
                                            {did.no_answer[+localStorage.getItem('atsLang') || 1]}:

                                        </span>
                                        <Select
                                            styles={customStyles}
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                            onChange={(ev) => handleChange('no_action', ev.value)}
                                            menuPortalTarget={document.body}
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isSearchable={true}
                                            value={shorts.find(s => s.virtual?.toString() === form.no_action?.toString()) ? { value: +form.no_action, label: `${shorts.find(s => +s.virtual === +form.no_action).virtual} (${shorts.find(s => +s.virtual === +form.no_action).name || ''})` } : { value: '', label: input.select[+localStorage.getItem('atsLang') || 1] }}
                                            name="color"
                                            options={[{ value: '', label: input.select[+localStorage.getItem('atsLang') || 1] }, ...shorts.map(s => ({ value: s.virtual, label: `${s.virtual} (${s.name || ''})` }))]}
                                        />
                                    </label> : null}


                                {didCreateData?.provider?.find(p => String(p.name) === String(form.operator))?.profile_type === 1 || edit ? <>

                                    <label className="col-md-12 count" style={{ margin: '20px 0' }}>
                                        <span>
                                            {did.profile[+localStorage.getItem('atsLang') || 1]} :
                                        </span>
                                        <select
                                            disabled={edit}
                                            value={form.profile}
                                            onChange={(ev) => handleChange('profile', ev.target.value)}
                                            style={{
                                                height: 40,
                                                border: '1px solid #ccc',
                                                outline: 'none'
                                            }}>
                                            <option
                                                value="">{input.select[+localStorage.getItem('atsLang') || 1]}</option>
                                            {didCreateData?.fix_provider?.map(p => (
                                                <option value={p.name} key={p.name}>{p.title}</option>
                                            ))}
                                        </select>
                                    </label>

                                    {form.profile && +form.profile !== 45 ? <>
                                        {+form.profile === 27 || (+form.profile === 42 && REACT_APP_SERVER === 'Beeline') ?
                                            <label style={{ margin: '20px 0' }} className="count col-md-12">
                                                <span>
                                                    Server host :
                                                </span>
                                                <input
                                                    readOnly={edit}
                                                    value={form.serverHost}
                                                    onChange={(ev) => handleChange('serverHost', ev.target.value)} />
                                            </label> : null}
                                        <label style={{ margin: '20px 0' }} className="count col-md-12">
                                            <span>
                                                {profile.username[+localStorage.getItem('atsLang') || 1]} :
                                            </span>
                                            <input
                                                readOnly={edit}
                                                value={form.username}
                                                onChange={(ev) => handleChange('username', ev.target.value)} />
                                        </label>

                                        <label style={{ margin: '20px 0' }} className="count col-md-12">
                                            <span>
                                                {profile.pass[+localStorage.getItem('atsLang') || 1]} :
                                            </span>
                                            <input
                                                readOnly={edit}
                                                type="password"
                                                value={form.password}
                                                onChange={(ev) => handleChange('password', ev.target.value)} />
                                        </label>
                                    </> : null}
                                </> : null}
                                <label style={{ margin: '20px 0' }} className="count col-md-12">
                                    <span>
                                        {did.line[+localStorage.getItem('atsLang') || 1]} :
                                    </span>
                                    <input onWheel={handleWheel} className="num_ok" type="number" value={form.line}
                                        onChange={(ev) => handleChange('line', ev.target.value)} />
                                </label>

                            </div>

                            <div className="d-flex justify-content-center" style={{ marginTop: 20 }}>
                                <button onClick={handleAdd} className="addBtnBig">
                                    {loader ? 'Loader...' : edit ? global.edit[+localStorage.getItem('atsLang') || 1] : sip.add_btn[+localStorage.getItem('atsLang') || 1]}
                                </button>
                            </div>
                        </form>
                    </Box>
                </Fade>

            </Modal>
            {telegram && session ?
                <TelegramCode setIsEmail={setIsEmail} open={telegram} setOpen={setTelegram} session={session}
                    setSession={setSession} storage={storage} setStorage={setStorage}
                    setFilter={setForm} /> : null}
            {isEmail ? <TelegramEmail open={isEmail} setOpen={setIsEmail} session={session} setSession={setSession}
                storage={storage} setStorage={setStorage} setFilter={setForm}
                setTelegram={setTelegram} /> : null}
        </>

    );
}

export default AddAndEditDidNumbers;
